import {http, HttpResponse} from "msw";
import {waitTime} from "@shared/mocks";
import {
    datasetSettings,
    devicesEntities,
    deviceStationsEntities,
    metricDevicesEntities,
    metricStationsEntities
} from "./entities";

const apiUrl = "*/api/v2";
const nodesUrl = apiUrl + "/dashboard/constructor/nodes";
const settingsUrl = apiUrl + "/dashboard/constructor/metrics/:metric_id/settings";
const devicesUrl = nodesUrl + "/devices";
const metricsUrl = nodesUrl + "/metrics";

const deviceStations = deviceStationsEntities;
const metricStations = metricStationsEntities;
const devices = devicesEntities;
const metricDevices = metricDevicesEntities;
const settings = datasetSettings;

const getDevices = http.get(devicesUrl, async ({request}) => {
    await waitTime(1000);

    const url = new URL(request.url);
    const stationId = url.searchParams.get("station_id");
    if (!stationId) {
        return HttpResponse.json(deviceStations);
    }

    return HttpResponse.json(devices);
});

const getMetricDevices = http.get(metricsUrl, async ({request}) => {
    await waitTime(1000);

    const url = new URL(request.url);
    const stationId = url.searchParams.get("station_id");
    if (!stationId) {
        return HttpResponse.json(metricStations);
    }

    return HttpResponse.json(metricDevices);
});

const getSettings = http.get(settingsUrl, async () => {
    await waitTime(1000);

    return HttpResponse.json(settings);
});

export const widgetConstructorHandlers = [
    getDevices,
    getMetricDevices,
    getSettings,
];
